import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { t } from 'i18next';

import { ToggleStoreState, ToggleStore } from '../../stores/ToggleStore';
import { UIHelper } from '../../utils/UIHelper';
import { MailHelper } from '../../utils/MailHelper';
import { AppConfigurationStore, DownloadOption } from '../../stores/AppConfigurationStore';
import { ViewSettingsStore } from '../../stores/ViewSettingsStore';
import { ViewSettingsActions } from '../../actions/ViewSettingsActions';
import { SidebarModule, MessageBoxType } from '../../constants/Enums';
import { LoadingCancelable } from '../LoadingCancelable';
import { UICoreButton } from '../UICoreButton';
import { LongButton } from '../LongButton';
import { ToggleGroup } from '../ToggleGroup';
import { DownloadButton } from '../DownloadButton';
import { ToggleActions } from '../../actions/ToggleActions';
import { ShareBaseTab } from './ShareBaseTab';

interface ShareMailState {
    exportSettings: ToggleStoreState;
}

export class ShareMail extends ShareBaseTab<ShareMailState> {
    public componentWillMount(): void {
        this.addStoreListener(ToggleStore, this.onChange);
        this.onChange();
    }

    public componentDidMount(): void {
        UIHelper.updateScrollbar(ReactDOM.findDOMNode(this) as Element);
    }

    public componentDidUpdate(): void {
        UIHelper.updateScrollbar(ReactDOM.findDOMNode(this) as Element);
    }

    public render(): JSX.Element | null {
        if (!this.props.visible) {
            return null;
        }
        return (
            <div className="sidebar-tab-container" key={this.props.layoutType.toString()}><div className="scrollbar-wcf">
                {this.header(t('Mail'))}
                <div className="sidebar-content standard-header">
                    <div className="long-button-group with-title active">
                        <LongButton
                            shortBorder={true}
                            toggled={(this.state.exportSettings.indexOf('IMAGE') !== -1)}
                            onClick={() => {ToggleActions.toggleType('IMAGE'); }}
                        >
                            {t('Image')}
                        </LongButton>
                    </div>
                    <ToggleGroup title={t('Commercial Information')}>
                        {AppConfigurationStore.getState().articleListTypes.map((option: DownloadOption, index: number) => {
                            return (
                                <DownloadButton
                                    key={index + '-al'}
                                    option={option}
                                    callback={ToggleActions.toggleType}
                                    toggled={this.state.exportSettings.indexOf(option.type) !== -1}
                                />
                            );
                        })}
                        {AppConfigurationStore.getState().commercialDownloadTypes.map((option: DownloadOption, index: number) => {
                            return (
                                <DownloadButton
                                    key={index + '-com'}
                                    option={option}
                                    callback={ToggleActions.toggleType}
                                    toggled={this.state.exportSettings.indexOf(option.type) !== -1}
                                />
                            );
                        })}
                    </ToggleGroup>
                    <ToggleGroup title={t('CAD Symbols')}>
                        {AppConfigurationStore.getState().cadDownloadTypes.map((option: DownloadOption, index: number) => {
                            return (
                                <DownloadButton
                                    key={index + '-cad'}
                                    option={option}
                                    callback={ToggleActions.toggleType}
                                    toggled={this.state.exportSettings.indexOf(option.type) !== -1}
                                />
                            );
                        })}
                    </ToggleGroup>
                    {this.button()}
                </div>
            </div></div>
        );
    }

    protected onChange = (): void => {
        this.setState({
            exportSettings: ToggleStore.getState()
        });
    };

    protected submit = (): void => {
        let resolveFromOutside: () => void;
        let killPromise: boolean = false;
        const keepAliveCheck: () => boolean = () => {
            return killPromise;
        };
        const mailCreatingPromise: Promise<void> = new Promise<void>((resolve, reject) => {
            resolveFromOutside = resolve;
            return UIHelper.timeout().then((): Promise<void> => {
                return MailHelper.generateShareLink(this.state.exportSettings, keepAliveCheck).then((link: string | null) => {
                    if (link == null) {
                        resolve();
                        return;
                    }
                    if (
                        true &&
                        link.indexOf('mailto:') === 0 &&
                        ViewSettingsStore.getBrowser() === 'Safari'
                    ) {
                        // Note: wrapping `mailto` links inside iframes does not work with safari; more details can be found in the README file
                        ViewSettingsActions.changeSidebar(SidebarModule.NONE);
                        window.location.href = link;
                    } else {
                        ViewSettingsActions.changeSidebar(SidebarModule.NONE);
                        ViewSettingsActions.showMessage({
                            wrap: false,
                            element: <iframe style={{display: 'none'}} key={Date.now()} src={link} width="1" height="1" frameBorder="0"/>,
                            type: MessageBoxType.DEFAULT
                        });
                    }
                    resolve();
                });
            });
        });
        ViewSettingsActions.withLock<void>(
            () => { return mailCreatingPromise; },
            <LoadingCancelable cancelCallback={() => { resolveFromOutside(); killPromise = true; }} label={t('Processing')}/>
        );
    };

    protected button = (): JSX.Element => {
        if (this.state.exportSettings.length > 0) {
            return (
                <UICoreButton color="green" align="block" onClick={this.submit} label={t('Send e-mail')}/>
            );
        }

        return (
            <UICoreButton color="light-grey" align="block" label={t('Send e-mail')}/>
        );
    };
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/sidebar/ShareMail.tsx